package space.stanton.pages.posts

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBp_2024_06_14_helloPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("posts/bp_2024_06_14_hello.md", FrontMatterElement.Builder { addScalar("title", "Hello world"); addScalar("type", "blogpost"); addScalar("date", "2024_06_14"); }))
}

@Page("/posts/bp-2024-06-14-hello")
@Composable
fun Bp_2024_06_14_helloPage() {
    space.stanton.components.layouts.BlogPost {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("This is the first post in my blog. Hopefully there is more coming soon...")
        }
    }
}
